import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination
} from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useEffect, useState } from "react";
import ToastMessage from "./toast-message";
import axios from "axios";
import uploadFileToCloud from "../utils/upload-file";

const ReviewingArticles = ({ status }) => {
  const [articles, setArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [openRejectDialog, setOpenRejectDialog] = useState({ open: false, action: '' });
  const [openApproveDialog, setOpenApproveDialog] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false); // <-- new
  const [actionStatus, setActionStatus] = useState({ type: 0, message: '' });

  // Pagination
  const [page, setPage] = useState(0);
  const articlesPerPage = 10;
  const startIdx = page * articlesPerPage;
  const endIdx = startIdx + articlesPerPage;
  const paginatedArticles = articles.slice(startIdx, endIdx);

  const clearToastMessage = () => {
    setActionStatus({ type: 0, message: '' });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setPdfFile(file);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const approveArticle = async () => {
    // if (!pdfFile) {
    //   setActionStatus({ type: 0, message: 'please upload article pdf' });
    //   return;
    // }
    setOpenApproveDialog(false);
    setLoading(true);
    

    try {

      // const nameWithoutExt = pdfFile.name.substring(0, pdfFile.name.lastIndexOf('.')).replace(/[^a-zA-Z0-9_-]/g, '_');
      // const extension = pdfFile.name.substring(pdfFile.name.lastIndexOf('.'));
      // const normalizedFileName = `${nameWithoutExt}_${Date.now()}${extension}`;
      // const path = `wajls/articles/${normalizedFileName}`;
  
      // const fileUrl = await uploadFileToCloud(pdfFile, path, (progress) => {
      //   console.log(`Upload progress: ${progress.toFixed(2)}%`);
      // });
        
      const payload = {
        id: selectedArticle.id,
        name: "Author",
        email: selectedArticle.email,
        // file_path: normalizedFileName,
        // blog_link: fileUrl
      };
      const response = await axios.post('https://api.wajls.com/admin/v1/accept_article.php', payload);

      setActionStatus({ type: response.data.success ? 1 : 0, message: response.data.message });

      if (response.data.success) {
        setArticles(prev => prev.filter(article => article.id !== selectedArticle.id));
      }

      // setPdfFile(null);
    } catch (error) {
      console.error(error);
    } finally {
      setOpenApproveDialog(false);
      setLoading(false);
    }
  };

  const rejectArticle = async () => {
    setOpenRejectDialog((prev) => ({ ...prev, open: false }));
    setLoading(true);

    try {
      const payload = {
        id: selectedArticle.id,
        name: "Author",
        email: selectedArticle.email,
        message: rejectReason
      };
      const response = await axios.post(
        `https://api.wajls.com/admin/v1/reject_article.php?notify=${openRejectDialog.action === "reject" ? 1 : 0}`, 
        payload
      );


      setActionStatus({ type: response.data.success ? 1 : 0, message: response.data.message });

      if (response.data.success) {
        setArticles(prev => prev.filter(article => article.id !== selectedArticle.id));
      }

      setRejectReason("");
    } catch (error) {
      console.error(error);
    } finally {
      setOpenRejectDialog(false);
      setLoading(false);
    }
  };

  const fetchArticles = async () => {
    if (status) {
      setFetchLoading(true);
      try {
        const response = await axios.get(`https://api.wajls.com/admin/v1/get_articles.php?status=0`);
        setArticles(response.data.articles || []);
        
      } catch (error) {
        console.error("Error fetching articles:", error);
      } finally {
        setFetchLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchArticles();
  }, [status]);

  return (
    <Box sx={{ mt: 4, margin: 'auto' }}>
      {/* FETCH LOADING */}
      {fetchLoading ? (
        <Paper elevation={3} sx={{ borderRadius: 2, p: 4 }}>
          <Skeleton height={40} width="60%" />
          <Skeleton height={40} width="90%" sx={{ mt: 2 }} />
          <Skeleton height={40} width="80%" sx={{ mt: 2 }} />
          <Skeleton height={40} width="95%" sx={{ mt: 2 }} />
        </Paper>
      ) : (
        <>
          {articles.length > 0 ? (
            <>
              <TableContainer
                component={Paper}
                elevation={3}
                sx={{ borderRadius: 2, overflowX: "auto" }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell><strong>Title</strong></TableCell>
                      <TableCell><strong>Authors</strong></TableCell>
                      <TableCell><strong>Phone</strong></TableCell>
                      <TableCell><strong>Email</strong></TableCell>
                      <TableCell align="right"><strong>Actions</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedArticles.map((manuscript) => (
                      <TableRow key={manuscript.id} hover>
                        <TableCell sx={{ maxWidth: 250 }}>
                          <Typography variant="body2">{manuscript.title}</Typography>
                        </TableCell>
                        <TableCell>
                          {manuscript.authors.map((author, i) => (
                            <a
                              key={author.id}
                              href={`https://wajls.com/author/?id=${author.id}&name=${encodeURIComponent(author.name)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                marginRight: 4,
                                color: "#1976d2",
                                textDecoration: "underline",
                                cursor: "pointer"
                              }}
                            >
                              {author.name}{i < manuscript.authors.length - 1 && ","}
                            </a>
                          ))}
                        </TableCell>
                        <TableCell>{manuscript.phone_number}</TableCell>
                        <TableCell>{manuscript.email}</TableCell>
                        <TableCell align="right">
                          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                            <Button
                              href={manuscript.url}
                              target="_blank"
                              variant="outlined"
                              size="small"
                              startIcon={<DownloadIcon />}
                            >
                              Download
                            </Button>
                            <Button
                              variant="contained"
                              color="success"
                              size="small"
                              startIcon={<CheckCircleIcon />}
                              onClick={() => {
                                setSelectedArticle(manuscript);
                                setOpenApproveDialog(true);
                              }}
                            >
                              Approve
                            </Button>
                            <Button
                              variant="contained"
                              color="error"
                              size="small"
                              startIcon={<CancelIcon />}
                              onClick={() => {
                                setSelectedArticle(manuscript);
                                setOpenRejectDialog({
                                  open: true,
                                  action: 'reject'
                                });
                              }}
                            >
                              Reject
                            </Button>
                            <Button
                              variant="outlined"
                              color="error"
                              size="small"
                              startIcon={<CancelIcon />}
                              onClick={() => {
                                setSelectedArticle(manuscript);
                                 setOpenRejectDialog({
                                  open: true,
                                  action: 'delete'
                                });
                              }}
                            >
                              Delete
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              <TablePagination
                component="div"
                count={articles.length}
                page={page}
                onPageChange={(event, newPage) => setPage(newPage)}
                rowsPerPage={articlesPerPage}
                rowsPerPageOptions={[]}
                onRowsPerPageChange={() => {}}
              />
            </>
          ) : (
            <Typography>No articles found</Typography>
          )}
        </>
      )}

      {/* Reject Dialog */}
      <Dialog open={openRejectDialog.open} onClose={() => setOpenRejectDialog({ open: false, action: '' })}>
        <DialogTitle>{openRejectDialog.action === 'reject' ? "Reject" : "Delete" } Article</DialogTitle>
        {openRejectDialog.action === "reject" && (
          <DialogContent>
            <TextField
              fullWidth
              multiline
              minRows={3}
              label="Reason for rejection (optional)"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              variant="outlined"
              sx={{ mt: 1 }}
            />
          </DialogContent>
        )}
        <DialogActions>
          <Button onClick={() => setOpenRejectDialog({ open: false, action: '' })}>Cancel</Button>
          <Button color="error" variant="contained" onClick={rejectArticle}>
            Confirm {openRejectDialog.action}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Approve Dialog */}
        <Dialog open={openApproveDialog} onClose={() => setOpenApproveDialog(false)}>
          <DialogTitle>Approve Article</DialogTitle>
          <DialogContent>
            {/* <Box sx={{ mt: 2 }}>
              <Button variant="outlined" component="label">
                Upload Article PDF
                <input type="file" accept="application/pdf" hidden onChange={handleFileChange} />
              </Button>
              {pdfFile && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Selected File: {pdfFile.name}
                </Typography>
              )}
            </Box> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenApproveDialog(false)}>Cancel</Button>
            <Button
              color="success"
              variant="contained"
              onClick={approveArticle}
              // disabled={!pdfFile}
            >
              Confirm Approve
            </Button>
          </DialogActions>
      </Dialog>

      {/* Action loading spinner */}
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Toast */}
      {actionStatus.message && (
        <ToastMessage
          type={actionStatus.type}
          message={actionStatus.message}
          onClose={clearToastMessage}
        />
      )}
    </Box>
  );
};

export default ReviewingArticles;
